module.exports = __webpack_public_path__ + "img/loginPasswordOrange.bd0edf2e.png";